import PDFAdobeViewer from 'modules/_shared/components/PDFAdobeViewer';

import CustomLoading from 'modules/_shared/components/CustomLoading';
import { useTranslate } from 'hooks/useTranslate';
import Loading from 'modules/_shared/components/Loading';
import { useGetDocumentFrame } from '../hooks/useGetDocumentFrame';

type Props = {
  htmlContent: string;
};

const LetterTabDocumentPreviewView = ({ htmlContent }: Props) => {
  const { t } = useTranslate();

  const documentFrameResult = useGetDocumentFrame({ htmlContent });

  const { documentFrame } = documentFrameResult.data;

  const { isLoading } = documentFrameResult;

  return (
    <div className="h-600px">
      {documentFrame && (
        <PDFAdobeViewer
          fileUrl={documentFrame}
          fileName={t('Document')}
          height="650px"
        />
      )}

      {isLoading && <CustomLoading />}
    </div>
  );
};

export default LetterTabDocumentPreviewView;
